let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("brOhQ")).then(() => parcelRequire('9WurS'));